import { useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { message } from 'antd';
import { enterKeyHandler } from "../../../_utils/keyboard_events";
import { toEnr } from "../../../_services/order.service";

const style = {
    position: 'absolute',
    marginTop: '50px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function ModalBarcode({ loadOrders = () => {} }){

    const [open, setOpen] = useState(false);
    const [focused, setFocused] = useState(false);

    const handleOpen = () => {
        setOpen(true);      
    };

    const handleClose = () => {
        setOpen(false);
    };

    const sendData = () => {
        const data = document.getElementById('barcode-input-enr').value;
        toEnr(data)
        .then(json => {
            if(json.ok){
                loadOrders();
                message.success('Enviado');
            } else {
                message.error(json.error);
            }            
        })
        .catch(err => {
            message.error(err.message);
        });
        document.getElementById('barcode-input-enr').value = '';
    }

    return(
        <div style={{ marginRight: '10px' }}>
            <Button variant='outlined' onClick={handleOpen}>Leer código de barras</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        
                        {
                            focused ?  
                            <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'green' }}>LISTO PARA PISTOLEAR</div>
                            : 
                            <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'red' }}>INGRESA EN EL CAMPO DE TEXTO</div>
                        }
                        <input
                            id="barcode-input-enr"
                            autoFocus
                            type="text"
                            onFocus={() => {
                                setFocused(true);
                            }}
                            onBlur={() => {
                                setFocused(false);
                            }}
                            onKeyUp={(e) => {
                                enterKeyHandler(e, () => {
                                    sendData();
                                })
                            }}
                        />
                    </div>
                </Box>
            </Modal>
        </div>
    );
}